/* Copyright (c) 2017 Backpack Health LLC */

import React, { SFC } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './ContentPanelFooter.css';

const ContentPanelFooter = (props) => {
  const includePadding = props.onCanvas || props.withPadding;

  return (
    <div className={classnames("cmp-contentpanelfooter", { 'util-frame-gutters withpadding': includePadding, '__on-canvas': props.onCanvas })}>
      {props.children}
    </div>
  );
}

export default ContentPanelFooter;
